var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEngEdit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 13.9766,
    height: 13.9745,
    viewBox: "0 0 13.9766 13.9745",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Container"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Symbol",
    d: "M9.92969 0.492188C10.276 0.164062 10.6862 0 11.1602 0V0C11.6341 0 12.0443 0.164062 12.3906 0.492188L13.4844 1.58594C13.8125 1.93229 13.9766 2.34245 13.9766 2.81641C13.9766 3.29036 13.8125 3.70052 13.4844 4.04688L12.1445 5.38672L8.58984 1.83203L9.92969 0.492188V0.492188V0.492188M11.543 5.98828L5.17188 12.3594C4.88021 12.651 4.53385 12.8607 4.13281 12.9883L0.851562 13.9453C0.596354 14.0182 0.377604 13.9544 0.195312 13.7539C0.0130208 13.5898 -0.0416667 13.3802 0.03125 13.125L0.988281 9.84375C1.11589 9.44271 1.32552 9.10547 1.61719 8.83203L7.98828 2.43359L11.543 5.98828V5.98828V5.98828",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngEdit);
export default __webpack_public_path__ + "static/media/eng-edit.54774419176f83420e7f31da7ffdef6d.svg";
export { ForwardRef as ReactComponent };